import styled from 'styled-components'
import { customTheme } from '../../../../styles/theme'

export const Card = styled.div`
  background: ${customTheme.colors.white};
  box-shadow: 0 4px 8px rgba(189, 189, 189, 0.2);
  padding: 40px 30px;
`
